import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getSkillsFromStore,
  addSkillToUser,
  filterSearchItem,
  deleteDraftSkill,
  clearDraft,
  retrieveFilteredSkillSets,
  changeActiveTab,
  getAllSkillSets,
  retrieveAllTemplates,
  retrieveDraftByEmail,
  retrieveMySkillSets,
  retrieveSkillSetByEmail,
  setUserEmail,
  setSelectedFilter
} from "../../../../../redux/actions/skill";
import { withRouter } from "react-router";
import { compose } from "redux";
import EmptyLoader from "../../../../../components/emptyLoader";
import Loader from "../../../../../components/loader";
import { notify } from "../../../../../redux/actions/snack";
import getColors from "../../../../../components/colors";
import MyDraftItem from "../MyDraftItem";
import { Pagination, Select, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import enablementIcon from "../../../../../images/my-skills-home/enablement.svg";
import walkthrough from "../../../../../images/template-img/walkthrough-icon.png";
import automation from "../../../../../images/template-img/automation-icon.png";
import dataLoading from "../../../../../images/template-img/data-loading.png";
import webAutomationIcon from "../../../../../images/template-img/web-automation.png";
import userOnboardingIcon from "../../../../../images/template-img/user-onboarding.png";
import backArrow from "../../../../../images/back-arrow.png";
import dataTransferIcon from "../../../../../images/dataTransferIcon.png";
import skillSetImage from "../../../../../images/SkillsetImage.png";
import Counter from "../../../../../components/counter";
import $ from "jquery";
import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html";
import {
  createDraftSkill,
  startRecord,
  stopRecord,
  sendRequestAccess,
  getSheetHeaders,
} from "../../../../../redux/actions/skill";

class SkillSets extends Component {
  constructor(props) {
    super(props);
    this.emailInputRef = React.createRef();
    this.state = {
      skills: [],
      filteredSkills: [],
      isLoading: true,
      isScrolling: false,
      hasMore: true,

      searchItem: "",
      backupSKills: [],
      checked: "all",
      activePage: 1,
      draftPage: 1,
      publishedPage: 1,
      itemsPerPage: 9,
      pendingPage: 1,
      userPage: 1,
      otherUserPage: 1,
      SKILL_NAME: "",
      SKILL_DESCRIPTION: "",
      TEMPLATE: "",
      isRecording: false,
      SKILL_ID: null,
      sheetUrl: null,
      fileUrl: null,
      sheetName: null,
      sheetRange: null,
      stopRecording: false,
      name: "",
      email: "",
      uploadedFileName: "",
      toogleFileView: false,
      isSendingInvite: false,
      requestTemplate: "",
      showCreateTemplate: false,
      isErrorDescription: false,
      dataHeaders: null,
      defaultTemplate: true,
      collectionName: "",
      collectionDescription: "",
      createdBy: "",
      displayContent: "",
    };
  }

  onFieldChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    const typedCharactersElement = this.state.SKILL_NAME?.length + 1;
    const maximumCharacters = 150;
    if (typedCharactersElement == maximumCharacters) {
      this.props.notify(
        "warning",
        "Skill name should not be more than 150 words"
      );
      return false;
    }

    if (this.state.SKILL_NAME.trim() !== "") {
      this.setState({
        isError: false,
      });
    }
    if (this.state.SKILL_DESCRIPTION.trim() !== "") {
      this.setState({
        isErrorDescription: false,
      });
    }
  };
  checkField = () => {
    if (this.state.SKILL_NAME.trim() === "") {
      this.setState({
        isError: true,
      });
    }
    if (this.state.SKILL_DESCRIPTION.trim() === "") {
      this.setState({
        isErrorDescription: true,
      });
    }
  };
  handleSubmit = async () => {
    this.setState({
      isLoading: true,
    });

    const { currentOrgUser, currentOrganization } =
      this.props.organizationReducer;

    if (currentOrgUser.role_id == "1") {
      this.props.notify(
        "error",
        "You do not have privileges to create a skill in the selected team"
      );
      this.setState({
        isLoading: false,
      });
      return;
    }
    if (this.state.SKILL_NAME.trim() === "") {
      this.props.notify("error", "Skill name cannot be empty");
      this.setState({
        isLoading: false,
      });
      return;
    }
    if (this.state.SKILL_DESCRIPTION.trim() === "") {
      this.props.notify("error", "Skill description cannot be empty");
      this.setState({
        isLoading: false,
      });
      return;
    } else {
      let skill = {
        ...this.state,
        SKILL_NAME: this.state.SKILL_NAME,
        USER_ID: this.props.userReducer.user_id,
        TYPE: "regularSkill",
        organisationId: currentOrganization?.id || null,
        status: "self",
        USER_EMAIL: this.props.userReducer.user.email,
        Rating: { upVotes: [], downVotes: [], userComments: [] },
      };

      if (this.state.sheetUrl && this.state.sheetName) {
        let headers = await this.props.getSheetHeaders(
          this.state.sheetUrl,
          this.state.sheetName
        );
        skill.dataHeaders = headers;
      }

      const createSkill = await this.props.createDraftSkill(skill, () => {});
      if (createSkill?.data?.status) {
        this.setState({
          isLoading: false,
          isRecording: true,
          SKILL_ID: createSkill.data.data.id,
        });

        this.props.notify("success", "Agent created successfully");
        this.props.history.push(
          `/dashboard/skills/viewSkill/${createSkill.data.data.id}`
        );
        this.props.changeActiveTab("Draft");
        $(".modal-backdrop").hide();
      } else {
        if (createSkill?.data?.response === "failed") {
          this.setState({
            isLoading: false,
          });
          this.props.notify("error", `${createSkill?.data?.error}`);
        } else {
          this.setState({
            isLoading: false,
          });
          this.props.notify("error", `${createSkill.msg}`);
        }
      }
    }
  };

  onEditorStateChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const blocks = contentState.getBlockMap();
    const fontFamilies = [
      "Arial",
      "Calibri",
      "Georgia",
      "Impact",
      "Tahoma",
      "Times New Roman",
      "Verdana",
    ];
    let fontFamiliesString = "";
    let htmlWithStyles = stateToHTML(contentState);

    blocks.forEach((block) => {
      const inlineStyles = block.getInlineStyleAt(0);
      const fontFamilyStyle = inlineStyles.find(
        (style) =>
          style.startsWith("fontfamily-") || fontFamilies.includes(style)
      );

      if (fontFamilyStyle) {
        const fontFamily = fontFamilyStyle.replace("fontfamily-", "");
        if (fontFamilies.includes(fontFamily)) {
          fontFamiliesString = fontFamily;
          htmlWithStyles = `<span style="font-family: ${fontFamily}">${htmlWithStyles}</span>`;
        }
      }
    });

    this.setState({
      editorState,
      SKILL_DESCRIPTION: htmlWithStyles,
    });
  };

  // componentDidMount() {
  //   if (
  //     this.state.checked === "published" ||
  //     this.state.checked === "draft" ||
  //     this.state.checked === "pending"
  //   ) {
  //     this.getFilteredSkill();
  //   } else {
  //     this.getDraftSkill();
  //   }
  // }
  componentDidMount() {
    const filter = this.props?.skillReducer?.selectedFilter
    if (filter === "published" || filter === "draft" || filter === "pending") {
      this.getFilteredSkill();
    } else if (filter === "CreatedBy Me") {
      this.handleUserSubmit();
    } else if (filter === "CreatedBy") {
      this.getSkillsByUserEmail();
    } else {
      this.getDraftSkill();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      activePage,
      publishedPage,
      draftPage,
      pendingPage,
      userPage,
      otherUserPage,
      inAppPage,
      userDocPage,
      userOnPage,
      webAutoPage,
      blankPage,
      skillSetPage,
      importPage,
      checked,
      selectedTemplate,
    } = this.state;
    if (activePage !== prevState.activePage) {
      this.getDraftSkill();
    } else if (
      publishedPage !== prevState.publishedPage ||
      draftPage !== prevState.draftPage ||
      pendingPage !== prevState.pendingPage
    ) {
      this.getFilteredSkill();
    } else if (userPage !== prevState.userPage) {
      this.handleUserSubmit();
    } else if (otherUserPage !== prevState.otherUserPage) {
      this.getSkillsByUserEmail();
    }
  }

  getDraftSkill = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    let page = parseInt(queryParams.get('page')) || 1;
    let data = { page };
    const userDraftSkill = await this.props.getAllSkillSets(data);
    if (userDraftSkill) {
      if (userDraftSkill?.results?.length) {
        this.setState({
          isLoading: false,
          skills: userDraftSkill?.results,
          isScrolling: false,
        });
      } else {
        this.setState({
          isLoading: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  getFilteredSkill = async () => {
    const filter = this.props?.skillReducer?.selectedFilter
    const queryParams = new URLSearchParams(window.location.search);
    let page = parseInt(queryParams.get('page')) || 1;
    let data = { page, filter };
    const filtered = await this.props.retrieveFilteredSkillSets(data);
    if (filtered) {
      if (filtered?.results?.length) {
        this.setState({
          isLoading: false,
          skills: filtered.results,
          isScrolling: false,
        });
      } else {
        this.setState({
          isLoading: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  handlePageChange = (pageNumber) => {
    this.setState({ activePage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);//setting the page parameter to the URL
    this.props.history.push({ search: queryParams.toString() });
  };

  handlePublishedPageChange = (pageNumber) => {
    this.setState({ publishedPage: pageNumber, isLoading: true }, () => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getFilteredSkill(pageNumber);
    });
  }
 
  handleDraftPageChange = (pageNumber) => {
    this.setState({ draftPage: pageNumber, isLoading: true }, () => {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set('page', pageNumber);
      window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
      this.getFilteredSkill(pageNumber);
    });
  }


  handlePendingPageChange = (pageNumber) => {
    this.setState({ pendingPage: pageNumber, isLoading: true }, () => {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set('page', pageNumber);
      window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
      this.getFilteredSkill(pageNumber);
    });
  }


  handleUserPageChange = (pageNumber) => {
    const filter = this.props?.skillReducer?.selectedFilter
    this.props.setSelectedFilter(filter)
    this.setState({ userPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.handleUserSubmit(pageNumber)
  };

  handleOtherUserPageChange = (pageNumber) => {
    this.setState({ otherUserPage: pageNumber, isLoading: true }, () => {
    });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getSkillsByUserEmail(pageNumber)
  };

  searchSkillStore = (e) => {
    this.setState({
      searchItem: e.target.value,
    });
  };

  onKeyPress = (e) => {
    if (e.key === "Enter") {
      this.setState({
        isSearching: true,
      });
      this.props.history.push({
        pathname: `/dashboard/skills/search/draft?query=${this.state.searchItem}`,
      });
    }
  };

  handleSelectChange = (value, pageNumber) => {
    this.props.setSelectedFilter(value);
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete('page');
    const queryString = queryParams.toString();
    const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
    window.history.replaceState({}, '', newUrl);
    this.setState(
      { checked: value, createdBy: "", skills: [], isLoading: true },
      () => {
        switch (value) {
          case "all":
            this.getDraftSkill(pageNumber);
            break;
          case "published":
            this.getFilteredSkill(pageNumber);
            break;
          case "draft":
            this.getFilteredSkill(pageNumber);
            break;
          case "pending":
            this.getFilteredSkill(pageNumber);
            break;
          case "byUser":
            this.setState({ isLoading: true})
            this.props.setSelectedFilter("all");
            this.getDraftSkill(pageNumber);
            break;
          default:
            // Handle default case if needed
            break;
        }
      }
    );
  };

  handleCreatedByChange = (value) => {
    this.props.setSelectedFilter(value)
    this.setState({
      createdBy: value,
      userEmail: "",
    });
  };

  validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  handleUserSubmit = async () => {
    if (this.state.createdBy === "CreatedBy Me") {
      this.setState({ checked: "CreatedBy Me" });
    }
    const queryParams = new URLSearchParams(window.location.search);
    let userPage = parseInt(queryParams.get('page')) || 1;
    const mainEmail = this.props?.userReducer?.user?.email;
    const filter = this.props?.skillReducer?.selectedFilter
    const pageSize = 9;
    const data = { page: userPage, pageSize };
    const currentOrgId =
      this.props?.organizationReducer?.currentOrgUser?.organization_id;
    const userDraftSkill = await this.props.retrieveMySkillSets(
      mainEmail,
      data,
      currentOrgId
    );
    if (userDraftSkill) {
      const content = `${filter ? filter : ""}`;
      if (userDraftSkill?.results) {
        this.setState({
          isLoading: false,
          skills: userDraftSkill.results,
          isScrolling: false,
          displayContent: content,
          checked: "byUser",
        });
      } else {
        this.setState({
          isLoading: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  getSkillsByUserEmail = async () => {
    if (this.state.createdBy === "CreatedBy") {
      this.setState({ checked: "CreatedBy" });
    }
    const queryParams = new URLSearchParams(window.location.search);
    let otherUserPage = parseInt(queryParams.get('page')) || 1;
    const { createdBy } = this.state;
    const email = this.props?.skillReducer?.userEmail
    const pageSize = 9;
    const data = { page: otherUserPage, pageSize };
    const currentOrgId =
      this.props?.organizationReducer?.currentOrgUser?.organization_id;
    const userDraftSkill = await this.props.retrieveSkillSetByEmail(
      data,
      currentOrgId,
      email
    );
    if (userDraftSkill) {
      if (userDraftSkill?.results) {
        const content = email ? email : (createdBy ? `${createdBy}:` : "");
        this.setState({
          isLoading: false,
          skills: userDraftSkill.results,
          isScrolling: false,
          displayContent: content,
          checked: "byUser",
        });
      } else {
        this.setState({
          isLoading: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };
  render() {
    const { createdBy } = this.state;
    const urlParams = new URLSearchParams(this.props.history.location.search);
    const AllPage = parseInt(urlParams.get('page')) || 1;
    const filter = this.props?.skillReducer?.selectedFilter
    const toolbarOptions = {
      options: ["inline", "blockType", "fontFamily", "list", "history"],
      inline: {
        options: ["bold", "italic", "underline"],
      },
      blockType: {
        options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6"],
      },
      fontFamily: {
        options: [
          "Arial",
          "Calibri",
          "Georgia",
          "Impact",
          "Tahoma",
          "Times New Roman",
          "Verdana",
        ],
      },
      list: {
        options: ["unordered", "ordered"],
      },
      history: {
        options: ["undo", "redo"],
      },
    };

    return (
      <React.Fragment>
        <div id="recordModal" class="rc-modal modal fade" role="dialog">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                onClick={() =>
                  this.setState({
                    SKILL_NAME: "",
                    SKILL_DESCRIPTION: "",
                    editorState: "",
                    TEMPLATE: "",
                    isRecording: false,
                    SKILL_ID: null,
                    isLoading: false,
                    stopRecording: false,
                    isErrorDescription: false,
                    isError: false,
                  })
                }
              >
                {" "}
                ×
              </button>
              <div class="modal-body">
                <div className="rc-modal-icon">
                  {this.state.TEMPLATE === "UserDocumentation" && (
                    <img src={automation} />
                  )}
                  {this.state.TEMPLATE === "In-App Walkthrough" && (
                    <img src={walkthrough} />
                  )}
                  {this.state.TEMPLATE === "UserOnboarding" && (
                    <img src={userOnboardingIcon} />
                  )}
                  {this.state.TEMPLATE === "WebAutomation" && (
                    <img src={webAutomationIcon} />
                  )}
                  {this.state.TEMPLATE === "Data Transfer" && (
                    <img src={dataTransferIcon} />
                  )}
                  {this.state.TEMPLATE === "In-App Walkthrough" && (
                    <img src={walkthrough} />
                  )}

                  {this.state.TEMPLATE ===
                    "Import Data from Spreadsheet to Web App" && (
                    <img src={dataLoading} />
                  )}
                  {this.state.TEMPLATE === "Skill Set" && (
                    <img src={skillSetImage} />
                  )}
                </div>

                {this.state.isRecording === true ? (
                  <React.Fragment>
                    <h3>
                      {" "}
                      <Counter state={this.state} />{" "}
                    </h3>
                    <h4 className="tlp-title">
                      Your Training starts in a new tab. Capture all steps that
                      you would like Super to learn. Once you are done with
                      training, Click on Stop button{" "}
                    </h4>
                  </React.Fragment>
                ) : this.state.TEMPLATE === "In-App Walkthrough" ? (
                  <h4 className="tlp-title text-center">
                    Name Your Enablement{" "}
                  </h4>
                ) : (
                  <h4 className="tlp-title text-center">
                    Name Your Automation{" "}
                  </h4>
                )}
                <div className="form-contain">
                  <div className="frm-block">
                    <div className="ip-tl-label">
                      <span className="tl-label">Skill Name</span>
                      <input
                        type="text"
                        name="SKILL_NAME"
                        placeholder="Enter Skill Name"
                        value={this.state.SKILL_NAME}
                        onChange={(e) => this.onFieldChange(e)}
                        onBlur={(e) => this.checkField()}
                        maxLength={"150"}
                      />
                      <div className="charCount">
                        <span id="typed-characters">
                          {" "}
                          {this.state.SKILL_NAME?.length}
                        </span>
                        <span>/</span>
                        <span id="maximum-characters">150</span>
                      </div>

                      {this.state.isError ? (
                        <label className="error text-danger">
                          Enter Skill Name
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="frm-block">
                    <div className="ip-tl-label">
                      <span className="tl-label">Description</span>
                      <div className="RichEditor-root">
                        <Editor
                          ref="editor"
                          spellCheck={false}
                          toolbarOnFocus={false}
                          editorState={this.state.editorState}
                          wrapperClassName="demo-wrapper"
                          editorClassName="demo-editor"
                          placeholder="Enter Description"
                          onEditorStateChange={this.onEditorStateChange}
                          onBlur={(e) => this.checkField()}
                          toolbar={toolbarOptions}
                        />
                      </div>
                      {this.state.isErrorDescription ? (
                        <label className="error text-danger">
                          Enter Skill Description
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                {this.state.isRecording === false ? (
                  <React.Fragment>
                    {this.state.isLoading ? (
                      <button className="btn btn-primary">
                        <div class="sp sp-circle text-light"></div>
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary"
                        onClick={() => this.handleSubmit()}
                      >
                        Next <img src={backArrow} />
                      </button>
                    )}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {this.state.stopRecording ? (
                      <button className="btn btn-primary" data-dismiss="modal">
                        <div class="sp sp-circle text-light"></div>
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary"
                        onClick={() => this.onStopRecord()}
                        data-backdrop="false"
                      >
                        Stop <img src={backArrow} />
                      </button>
                    )}
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="task-col-search">
          <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Skill Sets</h1>
              <div className="rt-btns">
                <button
                  className="btn btn-primary btn-black"
                  data-toggle="modal"
                  data-target="#recordModal"
                  onClick={() =>
                    this.setState({
                      TEMPLATE: "Skill Set",
                    })
                  }
                >
                  + Skill Set
                </button>
                <div className="filter-sort">
                  <Select
                    //defaultValue="Filter By"
                    value={this.props?.skillReducer?.selectedFilter}
                    style={{
                      width: 120,
                    }}
                    options={[
                      {
                        value: "all",
                        label: "Filters",
                      },
                      {
                        value: "published",
                        label: "Published",
                      },
                      {
                        value: "draft",
                        label: "Draft",
                      },
                      {
                        value: "pending",
                        label: "Pending",
                      },
                      {
                        value: "byUser",
                        label: (
                          <span data-toggle="modal" data-target="#userModal">
                            By User
                          </span>
                        ),
                      },
                    ]}
                    onChange={this.handleSelectChange}
                  />
                  {this.state.displayContent ? (
                    <div className="filter-badge">
                      <span>{this.state.displayContent}</span>
                      {/* <button className="close"
                        >
                        X
                      </button> */}
                         <Button
                          onClick={() => {
                            this.setState({ isLoading: true, createdBy: "", checked: "all", displayContent: "" });
                            this.props.setSelectedFilter("all")
                            this.props.setSelectedTemplate("all")
                            this.getDraftSkill();
                          }}
                          shape="circle"
                          icon={<CloseOutlined />} />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            <div
              id="userModal"
              class="modal fade crt-skill"
              role="dialog"
              data-keyboard="false"
              data-backdrop="static"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <div class="modal-dialog">
                <div class="modal-content crt-content">
                  <div class="modal-header">
                    <button type="button" 
                    class="close" 
                    data-dismiss="modal"
                    onClick={() => this.props.setUserEmail("")}>
                      &times;
                    </button>
                    <h4 class="modal-title">By User</h4>
                  </div>
                  <div class="modal-body">
                    <form class="form-contain" action="javascript:void(0)">
                      <div className="frm-block">
                        <div className="frm-radio-box">
                          <div className="frm-radio-item">
                            <input
                              type="radio"
                              value="CreatedBy Me"
                              checked={createdBy === "CreatedBy Me"}
                              onChange={() =>
                                this.handleCreatedByChange("CreatedBy Me")
                              }
                              id="CreatedBy Me"
                            />
                            <label for="CreatedBy Me">Created by Me</label>
                          </div>
                          <div className="frm-radio-item">
                            <input
                              type="radio"
                              value="CreatedBy"
                              checked={createdBy === "CreatedBy"}
                              onChange={() =>
                                this.handleCreatedByChange("CreatedBy")
                              }
                              id="CreatedBy"
                            />
                            <label for="CreatedBy">Created by Other User</label>
                          </div>
                        </div>
                        <div className="frm-email-input">
                          {createdBy === "CreatedBy" && (
                            <input
                              type="text"
                              placeholder="Enter email"
                              ref={this.emailInputRef}
                              value={this.props.userEmail}
                              onChange={(e) => this.props.setUserEmail(e.target.value)}
                            />
                          )}
                        </div>
                      </div>
                      <div class="frm-btns">
                        <button 
                        class="btn btn-outline" 
                        data-dismiss="modal"
                        onClick={() => this.props.setUserEmail("")}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary"
                          data-dismiss="modal"
                          onClick={() => {
                            this.setState({ isLoading: true }, () => {
                              if (this.state.createdBy === "CreatedBy Me") {
                                this.handleUserSubmit();
                              } else {
                                this.getSkillsByUserEmail(this.state.userEmail);
                              }
                            });
                          }}
                        >
                          {this.state.isLoading ? (
                            <div className="sp sp-circle text-light"></div>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {/* {this.state.checked === "all" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => (
                          <MyDraftItem
                            color={getColors(item.SKILL_NAME)}
                            key={key}
                            skill={item}
                            {...this.props}
                            deleteDraftSkill={this.deleteDraftSkill}
                          />
                        ))}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={this.state.activePage}
                              pageSize={9}
                              total={this.props.totalCount}
                              onChange={this.handlePageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : this.state.checked === "draft" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => (
                          <MyDraftItem
                            color={getColors(item.SKILL_NAME)}
                            key={key}
                            skill={item}
                            {...this.props}
                            deleteDraftSkill={this.deleteDraftSkill}
                          />
                        ))}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={this.state.draftPage}
                              pageSize={9}
                              total={this.props.filteredSkillSetCount}
                              onChange={this.handleDraftPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : this.state.checked === "pending" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => (
                          <MyDraftItem
                            color={getColors(item.SKILL_NAME)}
                            key={key}
                            skill={item}
                            {...this.props}
                            deleteDraftSkill={this.deleteDraftSkill}
                          />
                        ))}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={this.state.pendingPage}
                              pageSize={9}
                              total={this.props.filteredSkillSetCount}
                              onChange={this.handlePendingPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : this.state.checked === "published" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => (
                          <MyDraftItem
                            color={getColors(item.SKILL_NAME)}
                            key={key}
                            skill={item}
                            {...this.props}
                            deleteDraftSkill={this.deleteDraftSkill}
                          />
                        ))}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={this.state.publishedPage}
                              pageSize={9}
                              total={this.props.filteredSkillSetCount}
                              onChange={this.handlePublishedPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : this.state.createdBy === "CreatedBy Me" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => (
                          <MyDraftItem
                            color={getColors(item.SKILL_NAME)}
                            key={key}
                            skill={item}
                            {...this.props}
                            deleteDraftSkill={this.deleteDraftSkill}
                          />
                        ))}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={this.state.userPage}
                              pageSize={9}
                              total={this.props.totalSkillSetCount}
                              onChange={this.handleUserPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : this.state.createdBy === "CreatedBy" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => (
                          <MyDraftItem
                            color={getColors(item.SKILL_NAME)}
                            key={key}
                            skill={item}
                            {...this.props}
                            deleteDraftSkill={this.deleteDraftSkill}
                          />
                        ))}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={this.state.otherUserPage}
                              pageSize={9}
                              total={this.props.countByEmail}
                              onChange={this.handleOtherUserPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div> */}
              {filter === 'all' ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false && !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Skill Set found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills
                          .map((item, key) => (
                            <MyDraftItem
                              color={getColors(item.SKILL_NAME)}
                              key={key}
                              skill={item}
                              {...this.props}
                              deleteDraftSkill={this.deleteDraftSkill}
                            />
                          ))}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                              <Pagination
                                current={AllPage}
                                pageSize={9}
                                total={this.props.totalCount}
                                onChange={this.handlePageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              ) : filter === 'draft' ? (
                <div id="scrollableDiv" className="scrollable tl-scroll">
                  {this.state.isLoading ? (
                    <Loader
                      styles={{ width: "80px", margin: "auto" }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    <div>
                      {this.state.isLoading === false && !this.state.skills.length ? (
                        <div>
                          <EmptyLoader
                            style={{ width: "30%" }}
                            message="No Skill Set found"
                          />
                        </div>
                      ) : (
                        <div>
                          {this.state.skills
                            .map((item, key) => (
                              <MyDraftItem
                                color={getColors(item.SKILL_NAME)}
                                key={key}
                                skill={item}
                                {...this.props}
                                deleteDraftSkill={this.deleteDraftSkill}
                              />
                            ))}
                          <div className="template-flex">
                            <div className="template-box scrollable">
                              <Pagination
                                current={AllPage}
                                pageSize={9}
                                total={this.props.filteredSkillSetCount}
                                onChange={this.handleDraftPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : filter === 'pending' ? (
                <div id="scrollableDiv" className="scrollable tl-scroll">
                  {this.state.isLoading ? (
                    <Loader
                      styles={{ width: "80px", margin: "auto" }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    <div>
                      {this.state.isLoading === false && !this.state.skills.length ? (
                        <div>
                          <EmptyLoader
                            style={{ width: "30%" }}
                            message="No Skill Set found"
                          />
                        </div>
                      ) : (
                        <div>
                          {this.state.skills
                            .map((item, key) => (
                              <MyDraftItem
                                color={getColors(item.SKILL_NAME)}
                                key={key}
                                skill={item}
                                {...this.props}
                                deleteDraftSkill={this.deleteDraftSkill}
                              />
                            ))}
                          <div className="template-flex">
                            <div className="template-box scrollable">
                              <Pagination
                                current={AllPage}
                                pageSize={9}
                                total={this.props.filteredSkillSetCount}
                                onChange={this.handlePendingPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : filter === "CreatedBy Me" ? (
                <div id="scrollableDiv" className="scrollable tl-scroll">
                  {this.state.isLoading ? (
                    <Loader
                      styles={{ width: "80px", margin: "auto" }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    <div>
                      {this.state.isLoading === false && !this.state.skills.length ? (
                        <div>
                          <EmptyLoader
                            style={{ width: "30%" }}
                            message="No Skill Set found"
                          />
                        </div>
                      ) : (
                        <div>
                          {this.state.skills
                            .map((item, key) => (
                              <MyDraftItem
                                color={getColors(item.SKILL_NAME)}
                                key={key}
                                skill={item}
                                {...this.props}
                                deleteDraftSkill={this.deleteDraftSkill}
                              />
                            ))}
                          <div className="template-flex">
                            <div className="template-box scrollable">
                              <Pagination
                                current={AllPage}
                                pageSize={9}
                                total={this.props.totalSkillSetCount}
                                onChange={this.handleUserPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : filter === "CreatedBy" ? (
                <div id="scrollableDiv" className="scrollable tl-scroll">
                  {this.state.isLoading ? (
                    <Loader
                      styles={{ width: "80px", margin: "auto" }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    <div>
                      {this.state.isLoading === false && !this.state.skills.length ? (
                        <div>
                          <EmptyLoader
                            style={{ width: "30%" }}
                            message="No Skill Set found"
                          />
                        </div>
                      ) : (
                        <div>
                          {this.state.skills
                            .map((item, key) => (
                              <MyDraftItem
                                color={getColors(item.SKILL_NAME)}
                                key={key}
                                skill={item}
                                {...this.props}
                                deleteDraftSkill={this.deleteDraftSkill}
                              />
                            ))}
                          <div className="template-flex">
                            <div className="template-box scrollable">
                              <Pagination
                                current={AllPage}
                                pageSize={9}
                                total={this.props.countByEmail}
                                onChange={this.handleOtherUserPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : filter === "published" ? (
                <div id="scrollableDiv" className="scrollable tl-scroll">
                  {this.state.isLoading ? (
                    <Loader
                      styles={{ width: "80px", margin: "auto" }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    <div>
                      {this.state.isLoading === false && !this.state.skills.length ? (
                        <div>
                          <EmptyLoader
                            style={{ width: "30%" }}
                            message="No Skill Set found"
                          />
                        </div>
                      ) : (
                        <div>
                          {this.state.skills
                            .map((item, key) => (
                              <MyDraftItem
                                color={getColors(item.SKILL_NAME)}
                                key={key}
                                skill={item}
                                {...this.props}
                                deleteDraftSkill={this.deleteDraftSkill}
                              />
                            ))}
                          <div className="template-flex">
                            <div className="template-box scrollable">
                              <Pagination
                                current={AllPage}
                                pageSize={9}
                                total={this.props.filteredSkillSetCount}
                                onChange={this.handlePublishedPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  skills: state.skillReducer,
  userReducer: state.userReducer,
  searchTerm: state.searchTerm,
  appReducer: state.appReducer,
  snackReducer: state.snackReducer,
  skillReducer: state.skillReducer,
  organizationReducer: state.organizationReducer,
  totalCount: state.skillReducer.totalCount,
  filteredSkillSetCount: state.skillReducer.filteredSkillSetCount,
  totalSkillSetCount: state.skillReducer.totalSkillSetCount,
  countByEmail: state.skillReducer.countByEmail,
  userEmail: state.skillReducer.userEmail
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    createDraftSkill,
    getSkillsFromStore,
    addSkillToUser,
    filterSearchItem,
    notify,
    deleteDraftSkill,
    clearDraft,
    retrieveFilteredSkillSets,
    changeActiveTab,
    getAllSkillSets,
    retrieveAllTemplates,
    retrieveSkillSetByEmail,
    retrieveMySkillSets,
    setUserEmail,
    setSelectedFilter
  })
)(SkillSets);
